import { createFileRoute } from "@tanstack/react-router";
import { ContractPharmaciesActivityPage } from "@/features/contracts/contract-pharmacies-activity-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia/aktywnosc-aptek")({
	component: ContractPharmaciesActivityPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.aktywnosc-aptek",
			location.pathname,
		);
	},
});
